export const AUTH_CONFIG = {
    clientId: 'UQSwGob4IZYFBL3iPzAp2tgPd4GNthVh',
    domain: 'coroner.auth0.com',
    callbackUrl: `${window.location.protocol}//${window.location.host}/callback`,
    apiUrl: 'API_IDENTIFIER'
    //callbackUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:8080/callback' : 'http://localhost:8080/callback'
    //callbackUrl: process.env.NODE_ENV === 'development' ? 'https://coronertest.gannettpeaktech.com/callback' : 'https://coronertest.gannettpeaktech.com/callback'
}
